import { FaUserCircle } from 'react-icons/fa';
import { useTranslate } from 'react-translate';

const AboutMe = () => {
  const t = useTranslate('AboutMe');

  return (
    <section id='about' className='py-8 md:py-12'>
      <div className='section-shell'>
        <div className='grid gap-10 lg:grid-cols-[0.82fr_1.18fr] lg:items-start'>
          <div>
            <div
              className='section-kicker'
              data-aos='fade-up'
              data-aos-delay='50'
            >
              <FaUserCircle />
              {t('title')}
            </div>
            <h2
              className='section-title mt-6 max-w-md'
              data-aos='fade-up'
              data-aos-delay='100'
            >
              {t('headline')}
            </h2>

            <div
              className='stack-graphic mt-10 hidden sm:block'
              data-aos='fade-up'
              data-aos-delay='150'
            >
              <div className='stack-layer l1'></div>
              <div className='stack-layer l2'></div>
              <div className='stack-layer l3'></div>
            </div>

            <div
              className='mt-8 flex items-baseline gap-3'
              data-aos='fade-up'
              data-aos-delay='200'
            >
              <span className='stat-num-gradient text-4xl font-extrabold'>5+</span>
              <span className='text-xs font-bold uppercase tracking-[0.16em] text-[var(--text-soft)]'>
                {t('experience_label')}
              </span>
            </div>
          </div>

          <div
            className='grid gap-5 text-left'
            data-aos='fade-up'
            data-aos-delay='150'
          >
            <div className='panel'>
              <span className='panel-num'>01</span>
              <p className='panel-eyebrow'>{t('panel_one_title')}</p>
              <p className='panel-copy'>
                {t('one')}{' '}
                <b>{t('front_end')}</b>{' '}
                {t('one_middle')}{' '}
                <b>{t('back_end')}</b>
                .
              </p>
            </div>
            <div className='panel'>
              <span className='panel-num'>02</span>
              <p className='panel-eyebrow'>{t('panel_two_title')}</p>
              <p className='panel-copy'>
                {t('two')}{' '}
                <b>{t('data_base')}</b>{' '}
                {t('two_middle')}{' '}
                <b>{t('version_control')}</b>{' '}
                {t('two_final')}
              </p>
            </div>
            <div className='panel'>
              <span className='panel-num'>03</span>
              <p className='panel-eyebrow'>{t('panel_three_title')}</p>
              <p className='panel-copy'>{t('three')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
